var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.length > 0)?_c('div',{staticClass:"liefeng-picture-group"},_vm._l((_vm.data),function(item,index){return (item.image)?_c('img',{key:_vm.id + index,staticClass:"item",style:({
            margin: _vm.Y(item.marginTop) + ' ' + _vm.X(item.marginRight) + ' ' + _vm.Y(item.marginBottom) + ' ' + _vm.X(item.marginLeft),
            width: _vm.X(item.width),
            height: _vm.Y(item.height),
            'border-radius': item.radius ? 10 : '',
        }),attrs:{"src":item.image,"id":item.id},on:{"click":function($event){return _vm.click(item)}}}):_vm._e()}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }